import api from '@/services/api';
import gateway from '@/services/gravityGateway';
import timeFormat from '@/filters/timeFormat';

export default {
  load({ commit }, data) {
    const mutation = {
      sports: 'loadSports',
      tournaments: 'loadTournaments',
      bets: 'loadBets',
      matches: 'loadMatches',
    }[data.type];

    api.customSelectionEdit.get(data.type, data.params)
      .then((response) => {
        if (response.data) {
          commit(mutation, response.data);
        }
      })
      .catch((err) => {
        console.warn(`[${mutation}] Get selection error: `, err);
      });
  },
  getTournamentBetTemplates({ commit }, params) {
    api.customSelectionEdit.getTournamentBetTemplates({ sports: params.id_sport })
      .then((response) => {
        if (response.data && response.data.data) {
          const data = response.data.data.filter(value => value.active);

          commit('loadTournamentBetTemplates', data);
        }
      })
      .catch((err) => {
        console.warn('Error getting tournament bet templates: ', err);
      });
  },
  updateSelectionToRight({ commit }, data) {
    commit('updateSelectionToRight', data);
  },
  updateSelectionOptions({ commit }, data) {
    commit('updateSelectionOptions', data);
  },
  setSelectedId({ commit }, data) {
    commit('setSelectedId', data);
  },
  setCopiedBets({ commit }, data) {
    commit('setCopiedBets', data);
  },
  pasteCopiedBets({ commit }, data) {
    commit('pasteCopiedBets', data);
  },
  saveSelection({ getters }, params) {
    /* eslint-disable no-param-reassign */
    params.startDate = timeFormat.customSelectionEdit(params.startDate);
    params.endDate = timeFormat.customSelectionEdit(params.endDate);

    const types = ['sport', 'tournament', 'bet', 'match'];
    const body = types.map(type => ({
      action: `save${type.charAt(0).toUpperCase() + type.slice(1)}Selection`,
      data: {
        id_selection: params.idSelection,
        startDate: params.startDate,
        endDate: params.startDate,
        selection: getters.selection(type),
      },
    }));
    body.push({
      action: 'saveSelection',
      data: {
        selection_active: params.active,
        selection_name: params.selectionName,
        id_selection: params.idSelection,
        id_selection_config: params.selectionConfig,
        selection_content: {
          offer: params.content.offer,
          statistics: params.content.statistics,
        },
        startDate: params.startDate,
        endDate: params.startDate,
      },
    });

    api.customSelectionEdit.save({ params, body })
      .then(() => {
        api.customSelectionEdit.clearAdapterSelection({ idSelection: params.idSelection })
          .catch((err) => {
            console.warn('[saveSelection] Clear adapter selection error: ', err);
          });

        gateway.sendMessage({ action: 'success.saveSelection' });
      })
      .catch((err) => {
        console.warn('[saveSelection] Error: ', err);
        gateway.sendMessage({ action: 'error.saveSelection' });
      });
  },
  updateBetTemplateSelection({ commit }, item) {
    commit('updateBetTemplateSelection', item);
  },
};
